// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1343":"4ac985609f39c496","28398":"b6323009d4472833","48846":"6438dbb375600f1b","60657":"1bd95b5a858d1212","73527":"2e56990d0d424b39"}[chunkId] + ".css";
};